<template>
	<svg
		:width="props.size"
		:height="props.size"
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
	>
		<rect
			x="8.5957"
			y="9.97949"
			width="12.005"
			height="12.005"
			rx="2"
			transform="rotate(20.3109 8.5957 9.97949)"
			stroke="#FBFBFB"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M17.7708 19.7757L21.5236 21.1647C22.5598 21.5448 23.7084 21.0168 24.0946 19.9828L26.8726 12.4771C27.2527 11.4409 26.7247 10.2923 25.6907 9.90618L18.185 7.12811C17.1488 6.74804 16.0002 7.27608 15.6141 8.31002L14.225 12.0629"
			stroke="#FBFBFB"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M18.3935 10.4055C18.3467 10.5321 18.2282 10.6179 18.0934 10.6231C17.9585 10.6283 17.8339 10.5517 17.7775 10.4291C17.7211 10.3065 17.7442 10.162 17.8359 10.063C17.9276 9.96398 18.0699 9.92997 18.1964 9.97681"
			stroke="#FBFBFB"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M18.1969 9.97721C18.3697 10.0412 18.458 10.2331 18.394 10.4059"
			stroke="#FBFBFB"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M24.0244 12.489C23.9776 12.6156 23.8591 12.7014 23.7242 12.7066C23.5894 12.7118 23.4647 12.6352 23.4084 12.5126C23.352 12.39 23.375 12.2455 23.4667 12.1465C23.5584 12.0475 23.7008 12.0135 23.8273 12.0603"
			stroke="#FBFBFB"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M23.8258 12.0607C23.9986 12.1247 24.0869 12.3166 24.0229 12.4894"
			stroke="#FBFBFB"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M21.9404 18.1184C21.8764 18.2912 21.6845 18.3795 21.5117 18.3155C21.3389 18.2515 21.2507 18.0596 21.3146 17.8868C21.3786 17.714 21.5705 17.6257 21.7433 17.6897"
			stroke="#FBFBFB"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M21.7438 17.6896C21.9166 17.7536 22.0049 17.9455 21.9409 18.1183"
			stroke="#FBFBFB"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M16.3115 16.0349C16.2475 16.2077 16.0556 16.296 15.8828 16.232C15.71 16.168 15.6217 15.9761 15.6857 15.8033C15.7497 15.6305 15.9416 15.5422 16.1144 15.6062"
			stroke="#FBFBFB"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M16.113 15.6061C16.2858 15.6701 16.374 15.862 16.31 16.0348"
			stroke="#FBFBFB"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M10.6806 13.9514C10.6167 14.1242 10.4247 14.2125 10.2519 14.1485C10.0791 14.0845 9.99089 13.8926 10.0548 13.7198C10.1188 13.547 10.3107 13.4588 10.4836 13.5227"
			stroke="#FBFBFB"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M10.484 13.5226C10.6569 13.5866 10.7451 13.7785 10.6811 13.9513"
			stroke="#FBFBFB"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M12.4541 17.8079C12.3901 17.9807 12.1982 18.0689 12.0254 18.0049C11.8526 17.941 11.7643 17.749 11.8283 17.5762C11.8922 17.4034 12.0842 17.3152 12.257 17.3792"
			stroke="#FBFBFB"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M12.2575 17.3791C12.3405 17.4098 12.4079 17.4722 12.4448 17.5526C12.4818 17.633 12.4853 17.7248 12.4546 17.8078"
			stroke="#FBFBFB"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M14.2275 21.6643C14.1636 21.8371 13.9716 21.9254 13.7988 21.8614C13.626 21.7974 13.5378 21.6055 13.6017 21.4327C13.6657 21.2599 13.8576 21.1716 14.0304 21.2356"
			stroke="#FBFBFB"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M14.0309 21.2355C14.2037 21.2995 14.292 21.4914 14.228 21.6642"
			stroke="#FBFBFB"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M8.59861 19.5808C8.53465 19.7536 8.34271 19.8419 8.1699 19.7779C7.99709 19.7139 7.90886 19.522 7.97282 19.3492C8.03678 19.1764 8.22872 19.0881 8.40152 19.1521"
			stroke="#FBFBFB"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M8.40006 19.152C8.57287 19.216 8.6611 19.4079 8.59714 19.5807"
			stroke="#FBFBFB"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script setup>
defineOptions({
	name: 'ClubsCircleIcon',
})

const props = defineProps({
	size: {
		default: 32,
		type: Number,
	},
})
</script>
